import { Outlet } from 'react-router';
import { IcsFormPdfPreviewProvider } from './context/IcsFormPdfPreviewContext';

const IAPLayout = () => {
  return (
    <IcsFormPdfPreviewProvider>
      <div className="iap-layout">
        <div className="iap-layout__main">
          <Outlet />
        </div>
      </div>
    </IcsFormPdfPreviewProvider>
  );
};

export default IAPLayout;
